import ValidateVerificationCodeUseCase from './implementations/ValidateVerificationCodeUseCase';
import makeVerificationCodeRepository from '../../infra/repositories/makeValidateCodeRepository';

let instance: ValidateVerificationCodeUseCase | null = null;

export default function makeValidateCodeUseCase() {
  if (!instance) {
    const repository = makeVerificationCodeRepository();

    instance = new ValidateVerificationCodeUseCase(repository);
  }

  return instance;
}
